import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { AlertCircle, Lightbulb, ExternalLink, ArrowRight, CheckCircle2, BarChart3, ArrowRightCircle } from "lucide-react";

// Internal link map: keyword → route
const internalLinks: Record<string, string> = {
  // Pages villes
  "contrôle technique à Bagnolet": "/controle-technique-bagnolet",
  "contrôle technique à Vincennes": "/controle-technique-vincennes",
  "contrôle technique à Rosny-sous-Bois": "/controle-technique-rosny-sous-bois",
  "contrôle technique à Rosny": "/controle-technique-rosny-sous-bois",
  "contrôle technique à Fontenay-sous-Bois": "/controle-technique-fontenay-sous-bois",
  "contrôle technique à Fontenay": "/controle-technique-fontenay-sous-bois",
  "contrôle technique à Noisy-le-Sec": "/controle-technique-noisy-le-sec",
  "contrôle technique à Romainville": "/controle-technique-romainville",
  "contrôle technique à Montreuil": "/controle-technique-montreuil",
  "contrôle technique à Bondy": "/controle-technique-bondy",
  "contrôle technique à Les Lilas": "/controle-technique-les-lilas",
  "contrôle technique aux Lilas": "/controle-technique-les-lilas",
  "contrôle technique à Saint-Mandé": "/controle-technique-saint-mande",
  "Saint-Mandé": "/controle-technique-saint-mande",
  "Bondy": "/controle-technique-bondy",
  "Les Lilas": "/controle-technique-les-lilas",
  "Bagnolet": "/controle-technique-bagnolet",
  "Vincennes": "/controle-technique-vincennes",
  "Romainville": "/controle-technique-romainville",
  "Noisy-le-Sec": "/controle-technique-noisy-le-sec",
  "Fontenay-sous-Bois": "/controle-technique-fontenay-sous-bois",
  "Rosny-sous-Bois": "/controle-technique-rosny-sous-bois",
  "contrôle technique Montreuil": "/controle-technique-montreuil",
  // Pages SEO thématiques
  "tarifs contrôle technique pas cher dans le 93": "/controle-technique-pas-cher-93",
  "contrôle technique pas cher dans le 93": "/controle-technique-pas-cher-93",
  "réservation 24h/24 avec remise immédiate": "/contact",
  "contrôle technique pas cher": "/controle-technique-pas-cher-93",
  "contrôle technique moto": "/controle-technique-moto-93",
  "page dédiée au contrôle technique moto": "/controle-technique-moto-93",
  "CT moto dans le 93": "/controle-technique-moto-93",
  // Pages principales
  "nos tarifs": "/prestations",
  "tarifs et prestations": "/prestations",
  "page prestations": "/prestations",
  "notre centre": "/le-centre",
  "centre Autosur": "/le-centre",
  "notre centre de contrôle technique": "/le-centre",
  "notre FAQ": "/faq",
  "questions fréquentes": "/faq",
  // Pages véhicules
  "CT voiture": "/vehicules/voitures",
  "contrôle technique voiture": "/vehicules/voitures",
  "CT moto": "/vehicules/motos",
  "catégorie L": "/vehicules/motos",
  "véhicule de collection": "/vehicules/collection",
  "contrôle technique utilitaire": "/vehicules/utilitaires",
  "véhicules utilitaires": "/vehicules/utilitaires",
  // Articles blog
  "préparer son CT": "/blog/preparer-controle-technique-reussir-premier-coup",
  "préparer votre véhicule": "/blog/preparer-controle-technique-reussir-premier-coup",
  "10 vérifications": "/blog/preparer-controle-technique-reussir-premier-coup",
  "10 points de vérification": "/blog/preparer-controle-technique-reussir-premier-coup",
  "CT collection": "/blog/controle-technique-vehicule-collection-guide",
  "guide collection": "/blog/controle-technique-vehicule-collection-guide",
  "économiser sur votre contrôle technique": "/blog/economiser-controle-technique-93-astuces",
  "économiser sur le CT": "/blog/economiser-controle-technique-93-astuces",
  "contrôle technique en Seine-Saint-Denis": "/blog/controle-technique-93-seine-saint-denis-villes",
  "133 points de contrôle": "/blog/133-points-controle-technique-liste",
  "133 points vérifiés": "/blog/133-points-controle-technique-liste",
  "l'éclairage au contrôle technique": "/blog/eclairage-controle-technique-30-contre-visites",
  "défauts d'éclairage": "/blog/eclairage-controle-technique-30-contre-visites",
  "pneumatiques au CT": "/blog/pneus-controle-technique-regles-securite",
  "pneus au contrôle technique": "/blog/pneus-controle-technique-regles-securite",
  "état des pneus": "/blog/pneus-controle-technique-regles-securite",
  "système de freinage au contrôle technique": "/blog/freinage-controle-technique-conseils",
  "freinage au CT": "/blog/freinage-controle-technique-conseils",
  "voyant moteur allumé": "/blog/voyant-moteur-allume-controle-technique",
  "voyant moteur": "/blog/voyant-moteur-allume-controle-technique",
  "contre-visite": "/blog/contre-visite-controle-technique-delais-tarifs",
  "défauts critiques": "/blog/defauts-critiques-controle-technique",
  "défauts critiques au CT": "/blog/defauts-critiques-controle-technique",
  "premier contrôle technique à 4 ans": "/blog/premier-controle-technique-4-ans-guide",
  "premier CT à 4 ans": "/blog/premier-controle-technique-4-ans-guide",
  "quand passer son contrôle technique": "/blog/quand-passer-controle-technique-echeance",
  "échéance du CT": "/blog/quand-passer-controle-technique-echeance",
  "calendrier CT": "/blog/quand-passer-controle-technique-echeance",
  "vente de voiture": "/blog/vente-voiture-controle-technique-obligation",
  "CT avant vente": "/blog/vente-voiture-controle-technique-obligation",
  "documents nécessaires": "/blog/documents-necessaires-controle-technique",
  "documents à apporter": "/blog/documents-necessaires-controle-technique",
  "ZFE Grand Paris": "/blog/zfe-grand-paris-controle-technique-pollution",
  "zones à faibles émissions": "/blog/zfe-grand-paris-controle-technique-pollution",
  "CT camping-car": "/blog/controle-technique-camping-car-guide-complet",
  "contrôle technique camping-car": "/blog/controle-technique-camping-car-guide-complet",
  "CT utilitaire VUL": "/blog/controle-technique-utilitaire-vul",
  "sans rendez-vous": "/blog/controle-technique-sans-rendez-vous-montreuil",
  "CT sans rendez-vous": "/blog/controle-technique-sans-rendez-vous-montreuil",
  "véhicules GPL": "/blog/controle-technique-gpl-guide",
  "contrôle technique GPL": "/blog/controle-technique-gpl-guide",
  "véhicules hybrides": "/blog/controle-technique-hybride-electrique",
  "véhicules électriques": "/blog/controle-technique-hybride-electrique",
};

interface ArticleContentProps {
  content: string[];
}

type ParagraphType =
  | "illustration"
  | "main-title"
  | "sub-title"
  | "conclusion"
  | "introduction"
  | "list-item"
  | "callout-important"
  | "callout-tip"
  | "blockquote"
  | "internal-link"
  | "cta-block"
  | "infographic-checklist"
  | "infographic-stats"
  | "infographic-process"
  | "paragraph";

// Extract H2 titles from content for table of contents
export const extractTOCItems = (content: string[]): { title: string; id: string }[] => {
  return content
    .filter(p => {
      const trimmed = p.trim();
      // Match main titles: "1. Title", "2. Title" etc. (same logic as detectParagraphType)
      return /^\d+\.\s+[A-ZÀ-Ü]/.test(trimmed) && !trimmed.includes(":") && trimmed.length > 5 && trimmed.length < 120;
    })
    .map(p => {
      const title = p.trim();
      const id = title
        .toLowerCase()
        .replace(/^\d+\.\s+/, "")
        .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-|-$/g, "");
      return { title, id };
    });
};

const detectParagraphType = (text: string): ParagraphType => {
  const trimmed = text.trim();

  // Infographics
  if (trimmed.startsWith("[CHECKLIST:")) return "infographic-checklist";
  if (trimmed.startsWith("[STATS:")) return "infographic-stats";
  if (trimmed.startsWith("[PROCESS:")) return "infographic-process";

  // CTA blocks: [CTA:text|link]
  if (trimmed.startsWith("[CTA:")) return "cta-block";

  // Illustration placeholder
  if (trimmed === "[Illustration]" || trimmed.startsWith("[Illustration:")) return "illustration";

  // Main titles: "1. Title", "2. Title" - must be longer than a simple numbered item
  // and match uppercase (including accented: É, À, etc.)
  if (/^\d+\.\s+[A-ZÀ-Ü]/.test(trimmed) && !trimmed.includes(":") && trimmed.length > 5 && trimmed.length < 120) return "main-title";

  // Sub-titles: 1.1 Title, A. Title, etc.
  if (/^\d+\.\d+\s/.test(trimmed) || /^[A-Z]\.\s/.test(trimmed)) return "sub-title";

  // Conclusion / Introduction
  if (/^(Conclusion|En conclusion)/i.test(trimmed)) return "conclusion";
  if (/^(Introduction|En introduction)/i.test(trimmed)) return "introduction";

  // List items
  if (trimmed.startsWith("- ") || trimmed.startsWith("• ")) return "list-item";

  // Callouts
  if (/^(Important|Attention|À noter)\s*:/i.test(trimmed)) return "callout-important";
  if (/^(Conseil|Astuce|Bon à savoir)\s*:/i.test(trimmed)) return "callout-tip";

  // Internal link arrows
  if (trimmed.startsWith("→")) return "internal-link";

  // Blockquotes
  if (trimmed.startsWith("«") && trimmed.endsWith("»")) return "blockquote";

  return "paragraph";
};

// External link patterns (phone, address, etc.)
const externalLinks: Record<string, { href: string; target?: string }> = {
  "01 49 88 92 40": { href: "tel:0149889240" },
  "133 Boulevard Aristide Briand, 93100 Montreuil-sous-Bois": { href: "https://maps.app.goo.gl/QMbfid7TsPVr8ZB76", target: "_blank" },
};

// Format text with links, emphasis, and strong tags
const formatText = (text: string) => {
  // First handle <strong> tags
  const strongRegex = /<strong>(.*?)<\/strong>/g;
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  
  // Split by strong tags first
  const strongParts = text.split(/(<strong>.*?<\/strong>)/g);
  
  return strongParts.map((part, i) => {
    // Handle <strong> tags
    const strongMatch = part.match(/^<strong>(.*?)<\/strong>$/);
    if (strongMatch) {
      return <strong key={`s-${i}`} className="font-semibold text-autosur-navy">{strongMatch[1]}</strong>;
    }
    
    // Handle URLs
    const urlParts = part.split(urlRegex);
    return urlParts.map((urlPart, j) => {
      if (urlRegex.test(urlPart)) {
        try {
          const url = new URL(urlPart);
          return (
            <a
              key={`${i}-${j}`}
              href={urlPart}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 text-autosur-blue hover:underline"
            >
              {url.hostname}
              <ExternalLink className="w-3 h-3" />
            </a>
          );
        } catch {
          return urlPart;
        }
      }
      // Handle internal links in text
      return urlPart.split(/(«[^»]+»)/g).map((segment, k) => {
        if (segment.startsWith("«") && segment.endsWith("»")) {
          return (
            <em key={`${i}-${j}-${k}`} className="text-muted-foreground">
              {segment}
            </em>
          );
        }
        // Check for external link keywords (phone, address)
        const matchedExternal = Object.entries(externalLinks).find(([keyword]) =>
          segment.includes(keyword)
        );
        if (matchedExternal) {
          const [keyword, { href, target }] = matchedExternal;
          const idx = segment.indexOf(keyword);
          const before = segment.slice(0, idx);
          const matched = segment.slice(idx, idx + keyword.length);
          const after = segment.slice(idx + keyword.length);
          return (
            <React.Fragment key={`${i}-${j}-${k}`}>
              {before}
              <a href={href} target={target} rel={target ? "noopener noreferrer" : undefined} className="text-autosur-blue hover:underline font-semibold">{matched}</a>
              {after}
            </React.Fragment>
          );
        }
        // Check for internal link keywords
        const matchedLink = Object.entries(internalLinks).find(([keyword]) =>
          segment.toLowerCase().includes(keyword.toLowerCase())
        );
        if (matchedLink) {
          const [keyword, path] = matchedLink;
          const idx = segment.toLowerCase().indexOf(keyword.toLowerCase());
          const before = segment.slice(0, idx);
          const matched = segment.slice(idx, idx + keyword.length);
          const after = segment.slice(idx + keyword.length);
          return (
            <React.Fragment key={`${i}-${j}-${k}`}>
              {before}
              <Link to={path} className="text-autosur-blue hover:underline font-semibold">{matched}</Link>
              {after}
            </React.Fragment>
          );
        }
        return segment;
      });
    });
  });
};

export const ArticleContent = ({ content }: ArticleContentProps) => {
  const renderedContent = useMemo(() => {
    return content.map((paragraph, index) => {
      const type = detectParagraphType(paragraph);

      switch (type) {
        case "illustration":
          return null;

        case "infographic-checklist": {
          // Format: [CHECKLIST:Title|item1|item2|item3]
          const parts = paragraph.match(/^\[CHECKLIST:(.+)\]$/)?.[1]?.split("|");
          if (!parts || parts.length < 2) return null;
          const [title, ...items] = parts;
          return (
            <div key={index} className="my-8 p-6 bg-autosur-blue/5 rounded-2xl border border-autosur-blue/20">
              <h4 className="font-heading font-bold text-autosur-navy mb-4 flex items-center gap-2">
                <CheckCircle2 className="w-5 h-5 text-autosur-blue" />
                {title}
              </h4>
              <div className="grid sm:grid-cols-2 gap-2">
                {items.map((item, i) => (
                  <div key={i} className="flex items-start gap-2 font-body text-sm text-autosur-navy">
                    <span className="w-5 h-5 rounded-full bg-autosur-blue/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <CheckCircle2 className="w-3 h-3 text-autosur-blue" />
                    </span>
                    {item.trim()}
                  </div>
                ))}
              </div>
            </div>
          );
        }

        case "infographic-stats": {
          // Format: [STATS:Title|label1:value1|label2:value2]
          const parts = paragraph.match(/^\[STATS:(.+)\]$/)?.[1]?.split("|");
          if (!parts || parts.length < 2) return null;
          const [title, ...entries] = parts;
          const stats = entries.map(e => {
            const [label, value] = e.split(":");
            return { label: label?.trim(), value: value?.trim() };
          }).filter(s => s.label && s.value);
          return (
            <div key={index} className="my-8 p-6 bg-gradient-to-br from-autosur-navy to-autosur-blue rounded-2xl">
              <h4 className="font-heading font-bold text-white mb-4 flex items-center gap-2">
                <BarChart3 className="w-5 h-5" />
                {title}
              </h4>
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                {stats.map((stat, i) => (
                  <div key={i} className="text-center">
                    <div className="font-heading text-2xl font-bold text-white">{stat.value}</div>
                    <div className="font-body text-white/70 text-xs mt-1">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          );
        }

        case "infographic-process": {
          // Format: [PROCESS:Title|step1|step2|step3]
          const parts = paragraph.match(/^\[PROCESS:(.+)\]$/)?.[1]?.split("|");
          if (!parts || parts.length < 2) return null;
          const [title, ...steps] = parts;
          return (
            <div key={index} className="my-8 p-6 bg-gray-50 rounded-2xl border border-gray-200">
              <h4 className="font-heading font-bold text-autosur-navy mb-5 flex items-center gap-2">
                <ArrowRightCircle className="w-5 h-5 text-autosur-blue" />
                {title}
              </h4>
              <div className="flex flex-col gap-3">
                {steps.map((step, i) => (
                  <div key={i} className="flex items-start gap-3">
                    <span className="w-8 h-8 rounded-full bg-autosur-blue text-white font-heading font-bold text-sm flex items-center justify-center flex-shrink-0">
                      {i + 1}
                    </span>
                    <p className="font-body text-autosur-navy text-sm pt-1.5">{step.trim()}</p>
                  </div>
                ))}
              </div>
            </div>
          );
        }

        case "cta-block": {
          // Format: [CTA:Button text|/link/path]
          const ctaMatch = paragraph.match(/^\[CTA:(.+?)\|(.+?)\]$/);
          if (!ctaMatch) return null;
          const [, ctaText, ctaLink] = ctaMatch;
          return (
            <div key={index} className="my-8 p-6 bg-autosur-blue/5 rounded-2xl border border-autosur-blue/20 text-center">
              <p className="font-heading font-bold text-autosur-navy mb-3">Prêt à passer votre contrôle technique ?</p>
              <Link
                to={ctaLink}
                className="inline-flex items-center gap-2 px-6 py-3 bg-autosur-red text-white font-heading font-semibold rounded-full hover:bg-autosur-red-light transition-colors"
              >
                {ctaText}
                <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          );
        }

        case "main-title": {
          const titleId = paragraph.trim()
            .toLowerCase()
            .replace(/^\d+\.\s+/, "")
            .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
            .replace(/[^a-z0-9]+/g, "-")
            .replace(/^-|-$/g, "");
          return (
            <h2
              key={index}
              id={titleId}
              className="font-heading text-2xl md:text-3xl font-bold text-autosur-navy mt-10 mb-4 scroll-mt-24"
            >
              {paragraph}
            </h2>
          );
        }

        case "sub-title":
          return (
            <h3
              key={index}
              className="font-heading text-xl font-semibold text-autosur-navy mt-8 mb-3"
            >
              {paragraph}
            </h3>
          );

        case "conclusion":
        case "introduction":
          return (
            <h4
              key={index}
              className="font-heading text-lg font-semibold text-autosur-navy mt-8 mb-3 uppercase tracking-wider"
            >
              {paragraph}
            </h4>
          );

        case "list-item":
          return (
            <li
              key={index}
              className="font-body text-autosur-navy ml-4 mb-2 flex items-start gap-3"
            >
              <span className="w-1.5 h-1.5 bg-autosur-red rounded-full mt-2.5 flex-shrink-0" />
              <span>{formatText(paragraph.slice(2))}</span>
            </li>
          );

        case "callout-important":
          return (
            <div
              key={index}
              className="my-6 p-4 bg-red-50 border-l-4 border-red-500 rounded-r-lg"
            >
              <div className="flex items-start gap-3">
                <AlertCircle className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
                <p className="font-body text-autosur-navy">
                  {formatText(paragraph)}
                </p>
              </div>
            </div>
          );

        case "callout-tip":
          return (
            <div
              key={index}
              className="my-6 p-4 bg-autosur-blue/10 border-l-4 border-autosur-blue rounded-r-lg"
            >
              <div className="flex items-start gap-3">
                <Lightbulb className="w-5 h-5 text-autosur-blue flex-shrink-0 mt-0.5" />
                <p className="font-body text-autosur-navy">
                  {formatText(paragraph)}
                </p>
              </div>
            </div>
          );

        case "internal-link": {
          const linkText = paragraph.slice(2).trim();
          // Find matching internal link
          const matchedEntry = Object.entries(internalLinks).find(([keyword]) =>
            linkText.toLowerCase().includes(keyword.toLowerCase())
          );
          if (matchedEntry) {
            return (
              <Link
                key={index}
                to={matchedEntry[1]}
                className="my-3 flex items-center gap-2 text-autosur-blue font-heading font-semibold hover:text-autosur-navy transition-colors"
              >
                <ArrowRight className="w-4 h-4 flex-shrink-0" />
                {linkText}
              </Link>
            );
          }
          return (
            <p key={index} className="my-3 flex items-center gap-2 text-autosur-blue font-body">
              <ArrowRight className="w-4 h-4 flex-shrink-0" />
              {linkText}
            </p>
          );
        }

        case "blockquote":
          return (
            <blockquote
              key={index}
              className="my-6 pl-4 border-l-4 border-autosur-blue italic text-muted-foreground font-body"
            >
              {paragraph}
            </blockquote>
          );

        default:
          // Long paragraphs get special styling
          const isLong = paragraph.length > 400;
          return (
            <p
              key={index}
              className={`font-body text-autosur-navy leading-relaxed mb-4 ${
                isLong ? "p-4 bg-gray-50 rounded-lg border border-gray-100" : ""
              }`}
            >
              {formatText(paragraph)}
            </p>
          );
      }
    });
  }, [content]);

  return <div className="prose prose-lg max-w-none">{renderedContent}</div>;
};
